module.exports = __webpack_public_path__ + "static/img/prq2.7c48d5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq2.jpg
// module id = 34/p
// module chunks = 2